module.exports = __webpack_public_path__ + "static/media/ibiza.82bd05b2.jpg";